<template>
  <div>
    <gSwiperCommon :bannerType="'show.page.home.pc'"></gSwiperCommon>
    <div class="home">
      <div class="live-module" v-if="bannerList&&bannerList.length" >
        <div class="lm-l">
          <div
            class="lm-l-item"
            v-for="(item, index) in bannerList"
            :key="'list' + index"
            @click="linkTo(item)"
          >
            <img v-if="item.covers" :src="item.covers" />
            <img v-else src="@/assets/img/xwyd.png" alt="">
          </div>
        </div>
        <div class="lm-r">
          <div
            class="lm-r-item"
            @click="$router.push(`/home/about/${exhibitionId}`)"
          >
            <div class="item">
              <i class="icon iconfont icon-gaikuang" style="color: #5aaae5"></i>
              <p>展会概况</p>
            </div>
          </div>
          <div class="lm-r-item" @click="linkToRegSteps">
            <div class="item">
              <i class="icon iconfont icon-reg" style="color: #f2a234"></i>
              <p>注册参观</p>
            </div>
          </div>
          <div class="lm-r-item">
            <a
              class="item"
              :href="exhibitionInfo.website"
              target="_blank"
              v-if="exhibitionInfo && exhibitionInfo.website"
            >
              <i class="icon iconfont icon-demo17" style="color: #eb675e"></i>
              <p>官网链接</p>
            </a>
            <Tooltip
              content="暂未开放"
              placement="bottom"
              v-else
              style="height: 100%; display: flex"
            >
              <div class="item no-info">
                <i class="icon iconfont icon-demo17" style="color: #666"></i>
                <p>官网链接</p>
              </div>
            </Tooltip>
          </div>
          <div class="lm-r-item">
            <div class="item no-info" v-if="false">
              <i
                class="icon iconfont icon-tudi-xianxing-cu"
                style="color: #b86df2"
              ></i>
              <p>展位预览</p>
            </div>
            <Tooltip
              content="暂未开放"
              placement="bottom"
              v-else
              style="height: 100%; display: flex"
            >
              <div class="item no-info">
                <i
                  class="icon iconfont icon-tudi-xianxing-cu"
                  style="color: #666"
                ></i>
                <p>展位预览</p>
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
      <div class="g-layout">
        <div class="g-layout-l">
          <div class="m-card" v-if="demandList && demandList.length">
            <div class="mc-top">
              <div class="mc-top-title">
                <span class="mc-top-txt s-bold s-primary">供需商机</span>
              </div>
              <div class="mc-top-itembox">
                <div class="mc-tip-item" @click="changeDemand">换一组</div>
                <div
                  class="mc-tip-item"
                  @click="$router.push(`/home/demand/${exhibitionId}`)"
                >
                  更多
                </div>
              </div>
            </div>
            <template v-if="demandList && demandList.length">
              <div
                class="m-list"
                v-for="(item, index) in demandList"
                :key="'item' + index"
              >
                <div class="ml-item">
                  <div class="ml-item-l">{{ item.content }}</div>
                  <div class="ml-item-r" v-if="item.member">
                    <img :src="item.member.avatarUrl" class="ml-item-img" />
                    <span class="ml-item-txt">{{ item.member.name }}</span>
                  </div>
                </div>
              </div>
              <div class="u-btn">
                <Button
                  size="large"
                  type="primary"
                  ghost
                  long
                  @click="$refs.needsModel.open()"
                  >免费发布供需</Button
                >
              </div>
            </template>
            <div v-else class="u-empty">暂无数据</div>
          </div>
          <div class="m-card" v-if="false">
            <div class="mc-top">
              <div class="mc-top-title">
                <span class="mc-top-txt s-bold s-primary">行业人脉</span>
              </div>
              <div class="mc-top-itembox">
                <div
                  class="mc-tip-item"
                  @click="$router.push(`/home/demand/${exhibitionId}`)"
                >
                  更多
                </div>
              </div>
            </div>
            <div class="m-info">
              <div
                class="mi-item"
                v-for="(item, index) in [2, 2, 2, 2]"
                :key="'m-info1' + index"
              >
                <div class="mi-item-img">
                  <img
                    src="https://dss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2057588226,2402156864&fm=111&gp=0.jpg"
                  />
                </div>
                <div class="mi-item-content">
                  <div class="mi-item-txt">
                    <span class="mii-txt1">异能靖</span>
                    <span class="mii-txt2">总经理</span>
                  </div>
                  <div class="u-brand s-orange">专业线</div>
                </div>
              </div>
            </div>
            <div class="u-btn" style="padding-top: 0" @click="linkToRegSteps">
              <Button size="large" type="primary" ghost long>立即注册</Button>
            </div>
          </div>
          <div class="m-card" v-if="contactList && contactList.length">
            <div class="mc-top">
              <div class="mc-top-title">
                <span class="mc-top-txt s-bold s-primary">联系我们</span>
              </div>
            </div>
            <div v-if="contactList && contactList.length">
              <div
                class="home-info"
                v-for="(item, index) in contactList"
                :key="'contact-' + index"
              >
                <div class="hi-l">
                  <p>
                    <span class="txt1">{{ item.fullName }}</span
                    ><span style="font-size: 12px; color: #8c8c8c">{{
                      item.title
                    }}</span>
                  </p>
                  <p v-if="item.phoneNumber">手机：{{ item.phoneNumber }}</p>
                  <p v-if="item.qQId">
                    QQ：<a
                      target="_blank"
                      :href="
                        'http://wpa.qq.com/msgrd?v=3&uin=' +
                        item.qQId +
                        '&site=qq&menu=yes'
                      "
                      >{{ item.qQId }}</a
                    >
                  </p>
                  <p v-if="item.email">邮箱：{{ item.email }}</p>
                </div>
                <div class="hi-r" v-if="item.weChatQrCode">
                  <img :src="item.weChatQrCode" />
                </div>
              </div>
            </div>
            <div v-else class="u-empty">暂无数据</div>
          </div>
          <div class="m-card" v-if="visitCount||(visitList && visitList.length)">
            <div class="mc-top">
              <div class="mc-top-title">
                <span class="mc-top-txt s-bold s-primary"
                  >访客
                  <template v-if="visitCount">
                    （共{{ visitCount }}人）
                  </template>
                </span>
              </div>
            </div>
            <div class="m-imglist" v-if="visitList && visitList.length">
              <div
                class="m-imglist-item s-6"
                v-for="(item, index) in visitList"
                :key="'m-imglist1-v-' + index"
              >
                <div class="imgbox">
                  <img :src="item.userInfo.avatarUrl" v-if="item.userInfo&&item.userInfo.avatarUrl" />
                  <img v-else src="@/assets/img/empty.png" />
                </div>
              </div>
            </div>
            <div v-else class="u-empty">暂无数据</div>
          </div>
        </div>
        <div class="g-layout-r">
          <!-- 品牌展商 -->
          <div class="m-card" v-if="exhibitorList && exhibitorList.length">
            <div class="mc-top">
              <div class="mc-top-title">
                <span class="mc-top-txt s-bold s-primary">品牌展商</span>
              </div>
              <div class="mc-top-itembox">
                <div
                  class="mc-tip-item"
                  @click="$router.push(`/home/exhibitor/${exhibitionId}`)"
                >
                  更多
                </div>
              </div>
            </div>
            <div class="m-list2" style="padding: 20px 8px">
              <Row v-if="exhibitorList && exhibitorList.length">
                <Col
                  span="4"
                  v-for="(item, index) in exhibitorList"
                  :key="'m-list2-1' + index"
                  class="m-list2-box"
                >
                  <div
                    class="ml2-item"
                    @click="linkToExhibitorDetails(item.exhibitorId)"
                  >
                    <div class="ml2-item-box">
                      <img
                        :src="item.logo"
                        v-if="item.logo"
                        style="height: 100%"
                      />
                      <img v-else src="@/assets/img/empty.png" class="logo" />
                    </div>
                  </div>
                  <div class="ml2-item-info">
                    <p :title="item.name">{{ item.name }}</p>
                  </div>
                </Col>
              </Row>
              <div v-else class="u-empty">暂无数据</div>
            </div>
          </div>

          <!-- 同期活动 -->
          <div class="m-card" v-if="activityList && activityList.length">
            <div class="mc-top">
              <div class="mc-top-title">
                <span class="mc-top-txt s-bold s-primary">同期活动</span>
              </div>
              <div class="mc-top-itembox">
                <div
                  class="mc-tip-item"
                  :class="{ 's-primary': !activityHasLive }"
                  @click="
                    activityHasLive = false;
                    activityInit();
                  "
                >
                  热门
                </div>
                <div
                  class="mc-tip-item"
                  @click="
                    activityHasLive = true;
                    activityInit();
                  "
                  :class="{ 's-primary': activityHasLive }"
                >
                  有直播
                </div>
                <div
                  class="mc-tip-item"
                  @click="$router.push(`/home/activity/${exhibitionId}`)"
                >
                  更多
                </div>
              </div>
            </div>
            <div style="padding: 0 20px" class="act_wrap">
              <Row v-if="activityList && activityList.length">
                <Col
                  span="12"
                  v-for="(item, index) in activityList"
                  :key="'m-list3-1' + index"
                >
                  <div
                    class="m-list3 s-line"
                    style="padding: 20px 20px 20px 0"
                    @click="LinkAct(item)"
                  >
                    <div class="ml3-left">
                      <img :src="item.banners" v-if="item.banners" />
                      <img v-else src="@/assets/img/empty.png" />
                    </div>
                    <div class="ml3-right">
                      <div class="ml3-right-top">
                        <span class="ml3-txt" :title="item.title">{{
                          item.title
                        }}</span>
                        <span
                          class="u-brand2"
                          v-if="
                            item.hasLive &&
                            item.liveAuditState === 'PASS' &&
                            item.liveStateIndex == 1
                          "
                          >直播中</span
                        >
                      </div>
                      <div class="ml3-right-bottom">
                        <p>
                          时间：{{
                            item.startTime | moment("YYYY/MM/DD HH:mm")
                          }}
                          ~ {{ item.endTime | moment("HH:mm") }}
                        </p>
                        <p>地点：{{ item.address }}</p>
                        <p v-if="item.company">
                          {{ item.company.name }}
                        </p>
                        <p  v-else-if="item.isHostActivity"
                            >官方</p>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              <div v-else class="u-empty">暂无数据</div>
            </div>
          </div>

          <!-- 为您推荐 -->
          <div class="m-card pro_wrap" v-if="productList && productList.length||userProduct.length>1">
            <div class="mc-top">
              <div class="mc-top-title">
                <span class="mc-top-txt s-bold s-primary">为您推荐</span>
              </div>
              <div class="mc-top-itembox">
                <!-- <div
                  style="max-width: 130px"
                  class="mc-tip-item f-toe"
                  :class="{ 's-primary': productActive === '全部' }"
                  @click="setProductActive('全部')"
                  v-if=" userProduct && userProduct.length>1"
                >
                  全部
                </div> -->
                <template v-if="userProduct && userProduct.length>1">
                  <div
                    style="max-width: 130px"
                    class="mc-tip-item f-toe"
                    :class="{
                      's-primary':
                        item.indexOf(productActive) !== -1 && productActive,
                    }"
                    v-for="(item, index) in userProduct"
                    :key="'userPro-' + index"
                    :title="item"
                    @click="setProductActive(item)"
                  >
                    {{ item }}
                  </div>
                </template>
                <div
                  class="mc-tip-item"
                  @click="$router.push(`/home/product/${exhibitionId}`)"
                >
                  更多
                </div>
              </div>
            </div>
            <div class="m-list2" style="padding: 20px 10px">
              <Row v-if="productList && productList.length">
                <Col
                  span="6"
                  v-for="(item, index) in productList"
                  :key="'m-list222-1' + index"
                  class="m-list2-box"
                >
                  <div
                    class="ml2-item"
                    style="padding: 0 10px"
                    @click="linkToProductDetais(item.id)"
                  >
                    <div class="ml2-item-box">
                      <template
                        v-if="
                          item.video &&
                          JSON.parse(item.video).cover &&
                          JSON.parse(item.video).cover != 1
                        "
                      >
                        <img
                          :src="JSON.parse(item.video).cover"
                          v-if="JSON.parse(item.video).cover"
                          alt
                        />
                        <img v-else src="@/assets/img/empty.png" />
                      </template>
                      <template v-else>
                        <img :src="item.banner" v-if="item.banner" alt />
                        <img v-else src="@/assets/img/empty.png" />
                      </template>
                      <div class="rebang" v-if="item.isPopularize">
                        <div
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                        >
                          <i
                            class="iconfont icon-fire"
                            style="font-size: 14px; margin-right: 2px"
                          ></i>
                          热榜
                        </div>
                      </div>
                      <div class="is_threeD" v-if="item.view3DUrl">
                        <i
                          class="iconfont icon-d"
                          style="
                            font-size: 12px;
                            margin-left: 6px;
                            margin-right: 4px;
                            color: #ff5c00;
                          "
                        ></i>
                        <span
                          style="
                            font-size: 12px;
                            color: #ff5c00;
                            display: inline-block;
                          "
                          >3D</span
                        >
                      </div>
                      <div class="qj_div" v-if="item.panoramaUrl">
                        <i class="iconfont icon-yuanxitubiao-"></i>
                      </div>
                      <!-- <img :src="item.banner" v-if="item.banner" />
                      <img v-else src="@/assets/img/empty.png" /> -->
                      <div
                        class="play_video"
                        v-if="item.video && JSON.parse(item.video).url"
                      >
                        <i class="iconfont icon-shipinmianxing"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="ml2-item-info"
                    style="height: 71px; padding: 11px 10px 18px"
                  >
                    <p :title="item.name">{{ item.name }}</p>
                    <p style="color: #666">{{ item.selling }}</p>
                  </div>
                </Col>
              </Row>
              <div v-else class="u-empty">暂无数据</div>
            </div>
          </div>

          <div
            class="g-layout2"
            v-if="
              (videoList && videoList.length) || (newsList && newsList.length)
            "
          >
            <div class="g-layout2-l">
              <!-- 为您推荐 -->
              <div class="m-card" v-if="videoList && videoList.length">
                <div class="mc-top">
                  <div class="mc-top-title">
                    <span class="mc-top-txt s-bold s-primary">精彩视频</span>
                  </div>
                  <!-- <div class="mc-top-itembox">-->
                  <!-- <div class="mc-tip-item">更多</div>-->
                  <!-- </div>-->
                </div>
                <div
                  class="m-list2 video_wrap"
                  v-if="videoList && videoList.length"
                >
                  <Row>
                    <Col
                      span="12"
                      v-for="(item, index) in videoList"
                      :key="'m-list2-1' + index"
                      class="m-list2-box"
                    >
                      <div class="ml2-item">
                        <div
                          class="ml2-item-box"
                          style="padding-top: 56.4102564%"
                        >
                          <videoPlayer
                            :ref="'videoplay'"
                            @onPlayerPlay="onPlayerPlay"
                            :url="item.url"
                            :index="index"
                            :cover="item.cover"
                          ></videoPlayer>
                          <!-- <img
                            :src="item.cover"
                          /> -->
                        </div>
                      </div>
                      <div class="ml2-item-info">
                        <p>{{ item.title }}</p>
                      </div>
                    </Col>
                  </Row>
                </div>
                <div v-else class="u-empty">暂无数据</div>
              </div>
            </div>
            <div class="g-layout2-r">
              <!-- 为您推荐 -->
              <div class="m-card" v-if="newsList && newsList.length">
                <div class="mc-top">
                  <div class="mc-top-title">
                    <span class="mc-top-txt s-bold s-primary">资讯头条</span>
                  </div>
                  <div class="mc-top-itembox">
                    <div
                      class="mc-tip-item"
                      @click="$router.push(`/home/news/${exhibitionId}`)"
                    >
                      更多
                    </div>
                  </div>
                </div>
                <div
                  v-if="newsList && newsList.length"
                  style="min-height: 190px"
                >
                  <template v-for="(item, index) in newsList">
                    <div
                      :key="'news-1-' + index"
                      @click="linkToNewsDetails(item.id)"
                    >
                      <div class="m-box" v-if="index === 0">
                        <div class="mb-left">
                          <div class="mb-title" :title="item.title">
                            {{ item.title }}
                          </div>
                          <p class="mb-txt">
                            {{ item.content }}
                          </p>
                          <p class="mb-txt2">
                            {{ item.createAt | moment("YYYY/MM/DD") }}
                          </p>
                        </div>
                        <div class="mb-right">
                          <img
                            :src="item.covers[0]"
                            v-if="item.covers && item.covers.length"
                          />
                          <img v-else src="@/assets/img/empty.png" />
                        </div>
                      </div>
                      <div class="m-list theme-1" v-else>
                        <div class="ml-item">
                          <div class="ml-item-l">{{ item.title }}</div>
                          <div class="ml-item-r">
                            <img
                              v-if="item.covers && item.covers.length"
                              :src="item.covers[0]"
                              class="ml-item-img"
                            />
                            <img v-else src="@/assets/img/empty.png" />
                            <span class="ml-item-txt">安琪</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div v-else class="u-empty">暂无数据</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <needsModel ref="needsModel"></needsModel>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import gSwiperCommon from "@components/gSwiperCommon/gSwiperCommon.vue";
import videoPlayer from "../components/videoPlayer";
import needsModel from "@components/needsModel";

export default {
  name: "home",
  components: {
    gSwiperCommon,
    needsModel,
    videoPlayer,
  },
  data() {
    return {
      visitCount: 0,
      bannerType: "show.page.home.ad.pc", // 首页广告

      bannerList: null, // bannner列表

      demandList: [], // 供需列表

      videoList: [], //精彩视频

      exhibitorList: [], // 品牌展商列表

      activityList: [], // 同期活动列表
      activityHasLive: false,

      productList: [], // 为你推荐展品 列表
      userProduct: [], // 用户感兴趣的类别
      productActive: "all", // 选中

      newsList: [], // 资讯列表
      contactList: [], // 展会联系人列表
      visitList: [], // 访客列表
      demandPageIndex: 1,
      demandPageSize: 5,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      exhibitionId: "getExhibitionId",
      exhibitionInfo: "getExhibitionInfo",
    }),
    demandOption() {
      let query = `
        query($query:QueryInput!){
          supplyDemandQuery{
            query(query:$query){
                hasNextPage
                pageIndex
                totalCount
                items {
                  content
                  imgUrls
                  memberId 
                  publisherType
                  viewCount
                  updateAt
                  type
                  commentCount
                  id
                  auditTime
                  member{
                    id
                    avatarUrl
                    company
                    jobTitle
                    name
                  }
                }
              }
            }
        }
      `;
      let where = {
        Equal: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        Equal1: {
          n: "auditState",
          v: 1,
        },
        Equal_isdeleted: {
          n: "isDeleted",
          v: false,
        },
      };
      let order = [{ N: "updateAt", v: 0 }];
      let opt = {
        query: query,
        variables: {
          query: {
            page: this.demandPageIndex,
            size: this.demandPageSize,
            where: JSON.stringify(where),
            order: JSON.stringify(order),
          },
        },
      };
      return opt;
    },
    exhibitorOption() {
      let query = `
        query exhibitorTopByLogo($exhibitionId: ID!) {
          exList:exhibitorTopByLogo(input:{exhibitionId:$exhibitionId,num:24}) {
            exhibitorId
            logo
            name
            shortName
          }
        }
      `;
      let opt = {
        query: query,
        variables: {
          exhibitionId: this.exhibitionId,
        },
      };
      return opt;
    },
    activityOption() {
      const query = `
        query($query:QueryInput!){
          activityQuery{
            query(query:$query){
              hasNextPage
              pageIndex
              items{
                  acvitityType
                  banners
                  company{
                    name
                  }
                  exhibitionId
                  exhibitorId
                  externalLink
                  followCount
                  isHostActivity
                  id
                  address
                  likeCount
                  shareCount
                  startTime
                  endTime
                  stateIndex
                  title
                  userCount
                  liveAuditState
                  hasLive
                  liveStateIndex
                  auditState
                  topic
                  topicIndex
                  viewCount
                  isShow
              }
            }
          }
        }
      `;
      let where = {
        equal_show: {
          n: "isShow",
          v: 1,
        },
        equal_IsShowExhibitor: {
          n: "IsShowExhibitor",
          v: 1,
        },
        equal_auditState: {
          n: "auditState",
          v: 1,
        },
        equal_exhibitionId: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        equal_isExhibitionActivity: {
          n: "isExhibitionActivity",
          v: 0,
        },
        notEqual_topic: {
          n: "topic",
          v: 0,
        },
      };
      if (this.activityHasLive) {
        where = {
          Equal: {
            n: "exhibitionId",
            v: this.exhibitionId,
          },
          Equal2: {
            n: "hasLive",
            v: true,
          },
          Equal3: {
            n: "liveAuditState",
            v: 1,
          },
          Equal4: {
            n: "isExhibitionActivity",
            v: 0,
          },
          Equal5: {
            n: "isShow",
            v: 1,
          },
        };
      }
      let order = [
        {
          n: "topic",
          v: 0,
        },
        {
          n: "topicIndex",
          v: 0,
        },
        {
          n: "auditTime",
          v: 0,
        },
      ];
      if (this.activityHasLive) {
        order = [
          { n: "LiveStateIndex", v: 1 },
          { n: "startTime", v: 1 },
          { n: "endTime", v: 0 },
          { n: "ViewCount", v: 0 },
          { n: "CreateAt", v: 0 },
        ];
      }
      let opt = {};
      return {
        query: query,
        variables: {
          query: {
            page: 1,
            size: 6,
            where: JSON.stringify(where),
            order: JSON.stringify(order),
          },
        },
      };
    },
    productOption() {
      let query = `
        query getProduct($query:QueryProductInput!) {
          getProduct(query:$query) {
            hasNextPage
            pageIndex
            items{
              category
              banner
              selling
              name
              id
              view3DUrl
              isPopularize
              panoramaUrl
              video
              exhibitor{
                isLiving
                company{
                  name
                }
              }
            }
          }
        }
      `;
      let ca = "";
      console.log(this.productActive,'哈哈')
      if (this.productActive && this.productActive !== "全部") {
        ca = [this.productActive];
      }
      let opt = {
        query: query,
        variables: {
          query: {
            exhibitionId: this.exhibitionId,
            page: this.page,
            size: this.size,
            categories: ca,
          },
        },
      };
      return opt;
    },
    newsOption() {
      let query = `
        query queryArticleType($query:QueryInput!){
          queryArticleType(query:$query){
            hasNextPage
            indexFrom
            pageIndex
            pageSize
            items{articleType
              author
              authorId
              commentCount
              content
              covers 
              externalUrl
              favoriteCount
              id
              introduction
              isDeleted
              itemId
              keywords
              likeCount
              metadata
              publishAt
              shareCount
              status
              subtitle
              title
              topic
              topping
              toppingEndAt
              toppingIndex
              toppingStartAt
              updateAt
              userCount
              viewCount
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "itemId",
          v: this.exhibitionId,
        },

        or: {
          Equal1: {
            n: "topic",
            v: 2,
          },
          Equal2: {
            n: "topic",
            v: 1,
          },
        },
      };
      let order = [
        {
          N: "toppingIndex",
          v: 0,
        },
        {
          N: "publishAt",
          v: 0,
        },
      ];
      let opt = {
        query: query,
        variables: {
          query: {
            page: 1,
            size: 5,
            where: JSON.stringify(where),
            order: JSON.stringify(order),
          },
        },
      };
      return opt;
    },
    contactOption() {
      let query = `
        query($where: String!) {
          customerServiceQuery {
            getList(where: $where) {
              fullName
              qQId
              phoneNumber
              weChatId
              weChatQrCode
              title
              email
            }
          }
        }
      `;
      let where = {
        equal_isDeleted: {
          n: "isDeleted",
          v: 0,
        },
        equal_exhibitionId: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
      };
      let opt = {
        query: query,
        variables: {
          where: JSON.stringify(where),
        },
      };
      return opt;
    },
    visitOption() {
      let query = `
        query($query:_Any!){
          exhibitionUserQuery {
            page(
              query: $query
            ) {
              totalCount
              items {
                userInfo
              }
            }
          }
        }
      `;
      let where = {
        equal: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
        // notequal: {
        //   n: "userId",
        // },
      };
      let opt = {
        query: query,
        variables: {
          query: {
            where: where,
            order: [{ n: "updateAt", v: 0 }],
          },
        },
      };
      return opt;
    },
    videoOption() {
      let query = `
        query($query:QueryInput!){
          exhibitionVideoQuery{
            query(query:$query){
              hasNextPage
              indexFrom
              pageIndex
              pageSize
              items{
                cover
                coverIndex
                createAt
                title
                url
                id
                showIndex
              }
            }
          }
        }
      `;
      let where = {
        Equal: {
          n: "exhibitionId",
          v: this.exhibitionId,
        },
      };
      let order = [
        {
          N: "showIndex",
          v: 0,
        },
        {
          N: "updateAt",
          v: 0,
        },
      ];
      let opt = {
        query: query,
        variables: {
          query: {
            page: 1,
            size: 4,
            where: JSON.stringify(where),
            order: JSON.stringify(order),
          },
        },
      };
      return opt;
    },
    isRegOk() {
      return (
        this.user &&
        this.user.inMember &&
        this.user.inMember.userRole &&
        this.user.inMember.userRole != "VISITOR" &&
        this.user.inMember.userRole != "Visitor"
      );
    },
  },
  created() { 
    document.title = this.exhibitionInfo ?  this.exhibitionInfo.name : '仁创线上展'; 
    this.setShare();
    this.bannerInit(); // banner
    this.demandInit(); // 供需列表初始化
    this.exhibitorInit(); // 品牌列表初始化
    this.activityInit(); // 同期活动初始化
    this.newsInit(); // 資訊初始化
    this.contactInit(); // 联系人初始化
    this.visitInit(); // 访客初始化
    this.videoInit(); //精彩视频初始化
    this.setUserProductHandle();
    this.productInit(); // 展品初始化
  },
  methods: {
    ...mapActions({
      graphqlPost: "graphqlPostByZXS",
      getShareConfig:'share/getShareConfig',
      getBannerByGraphal: "banner/getBannerByGraphal",
      linkToExhibitorDetails: "linkTo/linkToExhibitorDetails",
      LinkAct: "linkTo/LinkAct",
      linkToNewsDetails: "linkTo/linkToNewsDetails",
      linkToRegSteps: "linkTo/linkToRegSteps",
      linkToProductDetais: "linkTo/linkToProductDetais",
    }),
    async setShare(){
      let data=await this.getShareConfig({id:this.exhibitionId,name:'share.exhibition.config'});
      let share = {
        url:location.href,
        title:this.exhibitionInfo.name,
        desc:this.exhibitionInfo.name,
        summary:this.exhibitionInfo.remark,
        pics:this.exhibitionInfo.logo,
      };
      if(data){
        let dataJson=JSON.parse(data);
        if(dataJson.content){
          share.title=dataJson.content
        }
        if(dataJson.des){
          share.desc=dataJson.des;
          share.summary=dataJson.des;
        }
      }
      this.$store.commit('setShare',share);
    },
    async bannerInit() {
      this.bannerList=[];
      // banner 初始化
      let listData = await this.getBannerByGraphal(this.bannerType);
      if (listData.bannerQuery && listData.bannerQuery.by) {
        this.bannerList = listData.bannerQuery.by;
      }
      if(this.bannerList.length>3){
        this.bannerList=this.bannerList.slice(0,3);
      }
      if(this.bannerList.length>0){
        let n=Math.abs(this.bannerList.length-3);
        for (let i = 0; i < n; i++) {
          this.bannerList.push({covers:false});
        }
      }
      // console.log(this.bannerList)
      
    },
    async demandInit() {
      // 供需列表初始化
      let data = await this.graphqlPost(this.demandOption);
      this.demandTotalCount = data.data.supplyDemandQuery.query.totalCount;
      this.demandList = data.data.supplyDemandQuery.query.items;
      if (this.demandList) {
        this.demandList.forEach((c) => {
          if (c.imgUrls) {
            c.imgUrls = c.imgUrls.split(";");
          }
        });
      }
      console.log("demandList", this.demandList);
    },
    changeDemand() {
      // 供需 循环换一组
      if (this.demandPageIndex * this.demandPageSize > this.demandTotalCount) {
        this.demandPageIndex = 1;
      } else {
        this.demandPageIndex += 1;
      }
      this.demandInit();
    },

    async exhibitorInit() {
      let res = await this.graphqlPost(this.exhibitorOption);
      if (res.data && res.data.exList) {
        this.exhibitorList = res.data.exList;
      }
      console.log("exhibitorList", this.exhibitorList);
    },
    async activityInit() {
      let res = await this.graphqlPost(this.activityOption);
      let data = JSON.parse(JSON.stringify(res.data.activityQuery.query));
      if (data) {
        data.items.map((e, i) => {
          if (e.banners && e.banners.indexOf("[") != -1) {
            let arr = JSON.parse(e.banners);
            e.banners = arr[0];
          }
        });
        console.log(data.items,'同期活动')
        this.activityList = data.items;
      }
      console.log("activityList", this.activityList);
    },
    async productInit() {
      let res = await this.graphqlPost(this.productOption);
      let data = JSON.parse(JSON.stringify(res.data.getProduct));
      if (data) {
        data.items.forEach((e) => {
          if (e.category && e.category.indexOf("[") !== -1) {
            if (Array.isArray(JSON.parse(e.category))) {
              if (JSON.parse(e.category)[0]) {
                e.category = JSON.parse(e.category)[0].Value;
              } else {
                e.category = "";
              }
            } else {
              let cate = JSON.parse(e.category);
              e.category = cate.Value;
            }
          }
          if (e.banner && e.banner.indexOf("[") != -1) {
            let arr = JSON.parse(e.banner);
            e.banner = arr[0];
          }
        });
        this.productList = data.items;
      }
      console.log("productList", this.productList);
    },
    async newsInit() {
      let data = await this.graphqlPost(this.newsOption);
      let res = JSON.parse(JSON.stringify(data.data.queryArticleType));
      if (res && res.items.length) {
        res.items.forEach((e) => {
          if (e.covers && e.covers.indexOf("[") != -1) {
            e.covers = JSON.parse(e.covers);
          } else {
            e.covers = [];
          }
          e.publishAt = moment(e.publishAt).format("YYYY/MM/DD HH:mm:ss");
        });
      }
      this.newsList = res.items;
      console.log("newsList", this.newsList);
    },
    async contactInit() {
      let data = await this.graphqlPost(this.contactOption);
      let res = JSON.parse(JSON.stringify(data.data.customerServiceQuery));
      if (res && res.getList.length) {
        this.contactList = res.getList;
      }
      console.log("contactList", this.contactList);
    },
    async visitInit() {
      let data = await this.graphqlPost(this.visitOption);
      let res = JSON.parse(JSON.stringify(data.data.exhibitionUserQuery));
      this.visitCount = res.page.totalCount;
      if (res.page && res.page.items.length) {
        let arr=[];
        res.page.items.map((c) => {
          if (c.userInfo) {
            c.userInfo = JSON.parse(c.userInfo);
            arr.push(c);
          }
        });
        this.visitList = arr;
      }
      console.log("visitList", this.visitList);
    },
    async videoInit() {
      let data = await this.graphqlPost(this.videoOption);
      let res = JSON.parse(
        JSON.stringify(data.data.exhibitionVideoQuery.query)
      );
      this.videoList = res.items;
      console.log(res, "视频初始化");
    },
    onPlayerPlay(index) {
      let arr = this.$refs.videoplay;
      for (let i = 0; i < arr.length; i++) {
        if (i != index) {
          arr[i].pause();
        }
      }
    },
    setUserProductHandle() {
      let cateArr=[];
      if (this.user && this.user.inMember && this.user.inMember.category) {
        let arr=this.user.inMember.category.split(';');
        arr.forEach(e=>{
          let eArr=e.split('>');
          cateArr.push(eArr[0]);
        })
      }
      console.log(cateArr,'catear')
      this.userProduct = [...new Set(cateArr)];
      if(this.userProduct.length>0){
        this.productActive=this.userProduct[0];
      }else{
        this.productActive='全部'
      }
    },
    setProductActive(e) {
      // const arr = e.split("/");
      this.productActive = e;
      this.productInit();
    },
    linkTo(e) {
      if (e && e.url) {
        window.open(e.url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 1200px;
  margin: 0 auto;
  .m-imglist{
    max-height: 122px;
    overflow: hidden;
  }
  .pro_wrap {
    .m-list2 {
      ::v-deep .ivu-row {
        .m-list2-box {
          .ml2-item-box {
            .play_video {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              background: rgba(0, 0, 0, 0.2);
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 3;
              i {
                font-size: 48px;
                color: #fff;
              }
            }
            border: none;
            img {
              width: 100%;
              height: 100%;
              display: block;
              object-fit: cover;
            }
          }
        }
      }
    }
  }
  .video_wrap {
    padding: 20px 20px 0;
    ::v-deep .ivu-row {
      &::after,
      &::before {
        display: none;
      }
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .m-list2-box {
        float: initial;
        width: calc(50% - 5px);
        .ml2-item {
          padding: 0;
          .ml2-item-box {
            border: none;
            .video_box {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .ml2-item-info {
          padding: 10px 0;
        }
      }
    }
  }
  .m-card {
    margin-bottom: 10px;
    .m-list3 .ml3-txt {
      max-width: 100%;
    }
    .u-brand2 {
      flex-shrink: 0;
    }
  }
  .g-layout .g-layout-l {
    width: 310px;
  }
  .g-layout .g-layout-r {
    margin-left: 10px;
    flex-shrink: 0;
    width: 880px;
  }
  .g-layout2 .g-layout2-r {
    min-height: 220px;
  }
  .m-list .ml-item-l {
    width: auto;
  }
  .live-module {
    min-height: 185px;
    display: flex;
    margin: 20px 0;
    .lm {
      &-l {
        flex: 1;
        display: flex;
        justify-content: space-between;
        &-item {
          width: 328px;
          height: 185px;
          background: #ccc;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      &-r {
        width: 185px;
        height: 185px;
        margin-left: 10px;
        background-color: #fff;
        border: solid 1px #ededed;
        display: flex;
        flex-wrap: wrap;
        &-item {
          width: 50%;
          height: 50%;
          display: inline-block;

          &:nth-child(1) {
            border-right: solid 1px #ededed;
            border-bottom: solid 1px #ededed;
          }
          &:nth-child(2) {
            border-bottom: solid 1px #ededed;
          }
          &:nth-child(3) {
            border-right: solid 1px #ededed;
          }
          .item {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            text-align: center;
            height: 100%;
            padding: 12px;
            cursor: pointer;
            &:hover {
              background: #e7f4ff;
              color: #1890ff;
              p {
                color: #1890ff;
              }
            }

            .iconfont {
              font-size: 28px;
            }
            p {
              width: 100%;
              color: #333;
            }
          }
          .no-info {
            background: #e5e5e5;
            color: #666;
            &:hover {
              background: #e5e5e5;
              color: #666;
              p {
                color: #666;
              }
            }
          }
        }
      }
    }
  }
}
.home-info {
  padding: 20px;
  display: flex;
  .hi {
    &-l {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      p {
        width: 100%;
        font-size: 14px;
        color: #666;
        &:first-child {
          margin-bottom: 10px;
        }
        .txt1 {
          color: #333;
          margin-right: 5px;
        }
        .txt2 {
          font-size: 12px;
        }
      }
    }
    &-r {
      width: 76px;
      height: 76px;
      margin: auto;
      img {
        width: 100%;
        height: 100%;
        // border-radius: 10px;
      }
    }
  }
}
.act_wrap {
  ::v-deep .ivu-row {
    .ivu-col {
      &:nth-child(1),
      &:nth-child(2) {
        .s-line {
          &::after {
            display: none;
          }
        }
      }
      .s-line {
        &::after {
          bottom: auto;
          top: 0;
        }
      }
    }
  }
}
.brand {
  display: inline-block;
  padding: 1px 5px;
  height: 15px;
  line-height: 15px;
  font-size: 12px;
  background: #1890ff;
  color: #fff;
  border-radius: 4px;
  margin-right: 5px;
}
.rebang {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 48px;
      height: 20px;
      background-color: #ff5e00;
      color: #ffffff;
      font-size: 12px;
    }
.is_threeD {
      position: absolute;
      top: 0;
      right: 0px;
      width: 42px;
      height: 20px;
      background-color: #ffffff;
      border-radius: 0px 0px 0px 5px;
      border: solid 1px #ff5c00;
      display: flex;
      align-items: center;
    }
.qj_div{
  position: absolute;
  right: 15px;
  bottom:15px;
  background: rgba($color: #000000, $alpha: 0.4);
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  i{
    color: #fff;
    font-size: 24px;
  }
}
</style>
